import { LockKeyhole } from '@lucide/vue'
import { defineComponent, h, type VNode } from 'vue'

export function renderTemplateLockMark(locked: boolean): VNode | null {
  if (!locked) return null
  return h('span', {
    class: 'ren-decoration-template-lock-mark',
    title: '该字段由业务模板锁定',
    'aria-label': '该字段由业务模板锁定'
  }, [h(LockKeyhole, { size: 13, 'aria-hidden': 'true' })])
}

export default defineComponent({
  name: 'TemplateLockMark',
  props: { locked: { type: Boolean, default: false } },
  setup(props) {
    return () => renderTemplateLockMark(props.locked)
  }
})
